import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import OperationService, { OperationItem } from '#/services/OperationService';
import { Pagenate, PagenateData } from './parts/Pagenate';
import dayjs from 'dayjs';
import * as URI from 'urijs';
import { SpinnerView } from './parts/SpinnerView';
import { PAGE_SIZE } from '#/config/constant';
import { UserContext } from './App';
import { FilterView } from './parts/FilterView';

function Operation() {
  const ctx = useContext(UserContext);
  const service = new OperationService(ctx.userInfo!);
  const [operations, setOperations] = useState<OperationItem[]>();
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOperations(undefined);

    service
      .getList({
        ...page,
        ...uri.query(true),
      })
      .then(
        (res) => {
          setPage({
            ...page,
            ...res.page,
          });
          setOperations(res.data);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  let items = [<></>];
  if (operations === undefined) {
    items = [
      <tr key="spinner">
        <td colSpan={8}>
          <SpinnerView />
        </td>
      </tr>,
    ];
  } else if (operations.length > 0) {
    items = operations.map((data: OperationItem, idx: number) => {
      return (
        <tr key={idx}>
          <td>
            {data.role !== 'superuser' ? (
              <Link to={`/${data.role}/${data.user_id}`}>{data.user_id}</Link>
            ) : (
              data.user_id
            )}
          </td>
          <td>{data.role}</td>
          <td>{data.process}</td>
          <td>{dayjs(data.created_at).format('YYYY/MM/DD HH:mm:ss')}</td>
        </tr>
      );
    });
  } else {
    items = [
      <tr key="no-data">
        <td colSpan={8}>データがありません</td>
      </tr>,
    ];
  }

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView id={true} role={true} />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                <Table className="mb-0">
                  <thead>
                    <tr>
                      <th>ユーザID</th>
                      <th>権限</th>
                      <th>操作内容</th>
                      <th>日時</th>
                    </tr>
                  </thead>
                  <tbody>{items}</tbody>
                </Table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Operation;
